import { memo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { ROUTES } from '@/app/routes'

export const Header = memo(function Header() {
  const { t } = useTranslation()
  const location = useLocation()

  const navigation = [
    { name: t('nav.dashboard'), path: ROUTES.app.root },
    { name: t('nav.sources'), path: ROUTES.app.sources },
    { name: t('nav.pages'), path: ROUTES.app.pages },
    { name: t('nav.groups'), path: ROUTES.app.groups },
    { name: t('nav.topics'), path: ROUTES.app.topicsList },
  ]

  return (
    <header className="mb-6 flex items-center justify-between gap-6 rounded-xl border border-border bg-card p-5 px-6 shadow-sm">
      <div className="flex items-center gap-4">
        <Link
          to={ROUTES.app.root}
          className="text-xl font-semibold text-foreground no-underline"
        >
          Omni Sight
        </Link>
      </div>

      <nav className="flex gap-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.path
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'rounded-lg px-4 py-2 text-sm font-medium transition-colors duration-200 no-underline',
                isActive
                  ? 'bg-primary/15 text-foreground'
                  : 'text-muted-foreground hover:bg-white/5',
              )}
            >
              {item.name}
            </Link>
          )
        })}
      </nav>
    </header>
  )
})
